import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ElderHomePage from "./components/elder/ElderHomePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ElderHomePage />} />
        <Route path="*" element={<ElderHomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
